import { validationMixin } from 'vuelidate';
import { required, maxLength, minLength} from 'vuelidate/lib/validators';
// This is a description of the component
// OrderCreate : ___
// @group OrderCreate
export default {
    mixins: [validationMixin],
    validations: {
        checkboxProductDefect   : {
            required,
            maxLength : maxLength(5),
        },
        inputOtherDefects       : {
            minLength : minLength(2),
            maxLength : maxLength(500),

        },
        selectConditionCode     : { required },
        stepProductDefect       : ['checkboxProductDefect',   'inputOtherDefects',   'selectConditionCode']
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data() {
        return {
            stepProductDefect : null,
            symptomCodes: [
                {id: "140", label: "Ungewöhnliche Geräusche"},
                {id: "210", label: "Kein Empfang oder Verbindung"},
                {id: "160", label: "Schaden an Gehäuse / Äußeres"},
                {id: "760", label: "Datenspeicherproblem"},
                {id: "310", label: "Kein Bild"},
                {id: "670", label: "Fehlerhafte mechanische Funktion"},
                {id: "330", label: "Bildqualitätsfehler"},
                {id: "120", label: "Aufladungsfehler"},
                {id: "640", label: "Mechanische Geräusche"},
                {id: "180", label: "Besondere Kundenwünsche"},
                {id: "130", label: "Anzeigefehler"},
                {id: "110", label: "Netzteilproblem oder keine Funktion"},
                {id: "170", label: "Allgemeiner Funktionsfehler"},
                {id: "230", label: "Sende- / Verbindungsproblem"},
                {id: "220", label: "Schlechter Empfang oder Verbindung"}
            ],
            checkboxProductDefect : [],

            conditionCodes: [
                {id: "A", label: "Durch äußere Einwirkung / Erschütterung / Sturz"},
                {id: "K", label: "In Verbindung mit anderen Geräten, speziellem externen Zubehör, Adapter Kit"},
                {id: "M", label: "Für einen kurzen Moment nach dem Einschalten"},
                {id: "L", label: "Wasserschaden"},
                {id: "1", label: "Ständig vorhanden"},
                {id: "P", label: "Beim Ausschalten"},
                {id: "3", label: "Nach einiger Zeit"},
                {id: "2", label: "Zeitweise"},
                {id: "5", label: "In kalter Umgebung"},
                {id: "4", label: "In warmer Umgebung"},
                {id: "7", label: "Bei Erschütterung"},
                {id: "6", label: "Beim Umschalten"},
            ],
            selectConditionCode     : [],
            inputOtherDefects       : null,
            hasErrors               : false
        };
    },
    methods: {
        validateAll() {
            console.info('on validate product defect js');
            this.$v.stepProductDefect.$touch();
            if (this.$v.stepProductDefect.$anyError) {
                return false;
            } else {
                return true;
            }
        },
        validateStep() {
            if(!this.$v.stepProductDefect.$dirty) {
                return;
            } else {
                this.$v.stepProductDefect.$touch();
            }
        },
        getStepData() {
            let ret = {};
            ret.productDefects       = this.checkboxProductDefect;
            ret.productConditionCode = this.selectConditionCode;
            ret.productOtherDefects  = this.inputOtherDefects;


            // ret.originalSymptomCodes = this.symptomCodes;
            // ret.original conditionCodes SymptomCodes = this.symptomCodes;
            return ret;
        },
        // getConditionCodes() {
        //     console.info('getConditionCodesLabel');
        //     let ret = [];
        //     let me = this;
        //     this.selectConditionCode.forEach(function(defect) {
        //         console.log(code);
        //         ret.push(code.id);
        //     });
        //     return ret;
        // },
        getSymptomCodes() {
            console.info('getSymptomCodes');
            let ret = [];
            let me = this;
            this.checkboxProductDefect.forEach(function(code) {
                console.log(code);
                ret.push(code.id);
            });
            return ret;
        },
        getStepSubmitData() {
            let ret = {};
            // ret.productDefects       = this.checkboxProductDefect;
            // ret.productConditionCode = this.selectConditionCode;
            // ret.productOtherDefects  = this.inputOtherDefects;


            // ret.conditionCode    = this.selectConditionCode; //"A",
            ret.conditionCode    = this.selectConditionCode.id; //"A",
            // ret.symptomCodes     = this.checkboxProductDefect;  //["630", "760", "460"],
            ret.symptomCodes     = this.getSymptomCodes();  //["630", "760", "460"],
            ret.description      = this.inputOtherDefects;

            return ret;
        }
    },
    watch: {
        '$v.stepProductDefect.$anyError' : function(errors) {
            console.info('stepProductDefect has errors', errors);
            if (errors) {
                this.$emit('step-product-defect-has-errors');
            } else {
                this.$emit('step-product-defect-is-valid');

            }
        },
        '$v.stepProductDefect.$dirty' : function(dirty) {
            if (!dirty && !this.$v.stepProductDefect.$anyError) {
                console.info('stepProductDefect dirty', dirty);
                this.$emit('step-product-defect-is-valid');
            } else {
                if (this.$v.stepProductDefect.$anyError) {
                    this.$emit('step-product-defect-has-errors');
                }
            }
        }
    },
    computed: {
        conditionCodesErrors () {
            const errors = [];
            if (!this.$v.selectConditionCode.$dirty) {
                return errors;
            }
            if(!this.$v.selectConditionCode.required) {
                errors.push('conditionCodes is required');
            }
            return errors;
        },
        // checkboxProductDefectErrors () {
        //     const errors = [];
        //     if (!this.$v.checkboxProductDefect.$dirty) {
        //         return errors;
        //     }
        //     if(!this.$v.checkboxProductDefect.maxLength) {
        //         errors.push('Max. 5 !');
        //     }
        //     if(!this.$v.checkboxProductDefect.required) {
        //         errors.push('checkboxProductTraces is required.');
        //     }
        //     return errors;
        // },
        inputOtherDefectsErrors () {
            const errors = [];
            if (!this.$v.inputOtherDefects.$dirty) {
                return errors;
            }
            if(!this.$v.inputOtherDefects.minLength) {
                errors.push('Dieses Feld muss mindestens 2 Zeichen haben');
            }
            if(!this.$v.inputOtherDefects.maxLength) {
                errors.push('Dieses Feld kann maximal 500 Zeichen haben');
            }
            return errors;
        }
    }
};
